import React from "react";
import Router from "./Router";
import "./style/index.scss";
import {UserContextProvider} from "./context/UserContext";
const axios = require('axios').default;

axios.defaults.withCredentials = true;
function App () {
 return(
     <UserContextProvider>
         <div className="container">
             <Router/>
          </div>
     </UserContextProvider>
 );
}

export default App;